import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import "../assets/css/ChangePassword.css";
import axiosInstance from "../components/api/axiosInstance";

function ChangePassword({ onBack }) {
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear errors when user starts typing
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // Validation
    if (!formData.currentPassword || !formData.newPassword || !formData.confirmPassword) {
      setError("All fields are required");
      return;
    }

    if (formData.newPassword.length < 6) {
      setError("New password must be at least 6 characters");
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setError("New password and confirm password do not match");
      return;
    }

    if (formData.currentPassword === formData.newPassword) {
      setError("New password must be different from current password");
      return;
    }

    setLoading(true);

    try {
      const response = await axiosInstance.post('/change-password', {
        current_password: formData.currentPassword,
        new_password: formData.newPassword
      });

      if (response.data && response.data.status === "success") {
        const successMessage = response.data.message || "Password changed successfully!";
        setSuccess(successMessage);
        setFormData({
          currentPassword: "",
          newPassword: "",
          confirmPassword: ""
        });
        
        setTimeout(() => {
          if (onBack) onBack();
        }, 1500);
      } else {
        const errorMsg = response.data?.message || "Failed to change password. Please try again.";
        setError(errorMsg);
      }
    } catch (error) {
      const msg = error.response?.data?.message || error.response?.data?.error || (error.request ? "Network error." : "Change password failed.");
      console.error("Change password error:", msg);
      
      if (error.response && error.response.data) {
        const errorMsg = error.response.data.message || 
                        error.response.data.error || 
                        `Server error: ${error.response.status}`;
        setError(errorMsg);
      } else if (error.request) {
        setError("Network error. Please check your connection and try again.");
      } else {
        setError("Failed to change password. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="changepassword-container">
      <div className="changepassword-card">
        <button 
          type="button" 
          className="close-icon-btn" 
          onClick={onBack}
          disabled={loading}
          aria-label="Close"
        >
          <FaTimes />
        </button>
        <h2 className="changepassword-title">Change Password</h2>
        
        <form className="changepassword-form" onSubmit={handleSubmit}>
          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          <div className="form-group">
            <label>Current Password <span className="required">*</span></label>
            <input
              type="password"
              name="currentPassword"
              value={formData.currentPassword}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>New Password <span className="required">*</span></label>
            <input
              type="password"
              name="newPassword"
              value={formData.newPassword}
              onChange={handleInputChange}
              required
            />
            <span className="hint-text">Must be at least 6 characters</span>
          </div>

          <div className="form-group">
            <label>Confirm New Password <span className="required">*</span></label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-actions">
            <button type="submit" className="btn-change-password" disabled={loading}>
              {loading ? "Changing..." : "Change Password"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ChangePassword;
